// extracted by mini-css-extract-plugin
export default {"loaderwrapper":"loader_loaderwrapper__IeoR5","loader":"loader_loader__M-FUL","l41":"loader_l41__q-fgJ"};